<template>
  <div class="column is-3-desktop is-4-tablet is-12-mobile">
    <div class="columns is-vcentered is-mobile is-variable is-2">
      <div class="column is-narrow">
        <album-cover
          v-bind:album="album"
          v-bind:isSmall="true"
          v-on:click="playShuffle"
          class="artist-cover is-64x64 poly-cursor-pointer"
        >
          <span class="state-icon icon is-medium has-text-black is-overlay poly-hidden poly-visible-touch">
            <i class="mdi mdi-shuffle"></i>
          </span>
        </album-cover>
      </div>

      <div class="column poly-truncate">
        <dl>
          <dd class="artist-name has-text-weight-bold poly-truncate">
            <router-link v-bind:to="{ name: 'artist', params: { id: artist.id } }">
              {{ artist.name }}
            </router-link>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  import AlbumCover from '@/components/AlbumCover'

  import shuffleArray from '@/mixins/shuffleArray'

  export default {
    name: 'SearchArtistListItem',
    mixins: [shuffleArray],
    components: {
      AlbumCover
    },
    props: {
      artist: {
        type: Object,
        required: true
      }
    },
    computed: {
      album: function () {
        if (this.artist.albums.length) {
          return this.artist.albums[0]
        } else {
          return this.artist.features[0]
        }
      }
    },
    methods: {
      playShuffle: function () {
        this.fetchArtistTracks().then((response) => {
          var shuffledTracksToPlay = this.shuffleArray(response.data.tracks)

          if (this.$store.getters.currentTrack && shuffledTracksToPlay.length > 1) {
            while (shuffledTracksToPlay[0].id === this.$store.getters.currentTrack.id) {
              shuffledTracksToPlay = this.shuffleArray(shuffledTracksToPlay)
            }
          }

          this.$store.commit('playTracks', { tracks: shuffledTracksToPlay })
        }).catch(() => {
          console.error(`There was an error trying to get tracks for artist with id ${this.artist.id}`)
        })
      },
      fetchArtistTracks: function () {
        return this.$apollo.query({
          query: require('@/graphql/RandomArtistTracks.gql'),
          fetchPolicy: 'no-cache',
          variables: { artistId: this.artist.id }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/initial-variables";

  .artist-cover .state-icon {
    margin: auto;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 100%;
    border: 1px solid $white-ter;
  }
  .artist-cover:hover .state-icon { visibility: visible; }

  // Mobile specific modifiers
  @media (max-width: $tablet - 1) {
    .artist-name { font-size: 0.9rem; }
    .artist-cover .state-icon { transform: scale(1.0); }
  }
</style>
